import request from '@/utils/request.js'

export function getDeviceList(query) {
  return request({
    url: '/api/standard/aibox/software',
    method: 'get',
    params: query,
  })
}

// 新增设备
export function createDevice(data) {
  return request({
    url: '/api/standard/aibox/software',
    method: 'post',
    data,
  })
}

//授权列表
export const getAuthList = (query) => {
  return request({
    url: '/api/standard/devices/auth',
    method: 'get',
    params: query,
  })
}

export const deleteAuth = (id) => {
  return request({
    url: `/api/standard/aibox/software/${id}`,
    method: 'delete',
  })
}

export function getDeployList(query) {
  return request({
    url: '/api/standard/algorithm',
    method: 'get',
    params: query,
  })
}

//设备详情
export const getDeviceDetail = (id) => {
  return request({
    url: `/api/standard/algorithm/${id}`,
    method: 'get',
  })
}

// 下发设备
export function deliveryDevice(id, data) {
  return request({
    url: `/api/standard/algorithm/${id}/model/publish`,
    method: 'post',
    data,
  })
}

//系统枚举
export const getOptions = () => {
  return request({
    url: '/api/standard/algorithm/options',
    method: 'get',
  })
}

//检查版本
export const checkVersion = (version) => {
  return request({
    url: `/api/standard/aibox/software/exists?version=${version}`,
    method: 'get',
  })
}

//上传文件
export function uploadFiles(id, data) {
  return request({
    url: `/api/standard/aibox/software/${id}/upload`,
    method: 'post',
    data,
    headers: {
      'Content-type': 'multipart/form-data',
    },
  })
}
